import { useEffect, useState, useRef } from "react";
import Link from "next/link";
import {
  Container,
  Col,
  Form,
  Row,
  Button,
  FormLabel,
  FormSelect,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import styles from "@/styles/Courselisting.module.css";
import {
  setStates,
  setName,
  setSelectedSorting,
  setEmptyFilter,
  setSelectedCity,
  setSelectedState,
  setSelectedName,
  setCategoryTypes,
  setSelectedCategoryType,
} from "@/redux/features/healerCourseSlice.js";
import InfiniteScroll from "react-infinite-scroll-component";
import { useRouter } from "next/router";
import styless from "@/styles/PageLoader.module.css";
import Image from "next/image";
import Head from "next/head";
import moment from "moment-timezone";

const Courselisting = (props) => {
  const dispatch = useDispatch();
  const [healerCourses, setHealerCourses] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [listIndex, setListIndex] = useState(1);
  const [hasMo, setHasMo] = useState(true);
  const [setFilterPop, setshowfilter] = useState(false);
  const [apiLoader, setApiLoader] = useState(true);
  const [coursesMeta, setCoursesMeta] = useState(props?.coursesMeta ?? {});
  const [screenSize, setScreenSize] = useState();
  const [searchBar, setSearchBar] = useState(false);

  const { name, filters, states, categoryTypes } = useSelector(
    (state) => state.healerCourse
  );
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setScreenSize(window.innerWidth);
  }, []);

  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#002A0F" : "#fff",
        color: isFocused ? "#fff" : "#666",
        fontSize: "12px",
        fontWeight: "600",
        width: "135px",
      };
    },
  };

  const fetchHealerCourses = async (scroll = null) => {
    //if infinite scrolling then scroll will be true and will run with filters
    //else any filter is applied then scroll is null filter will be applied previos data will be removed and index will be reset to 1
    try {
      let index;

      if (scroll) {
        index = listIndex + 1;
      } else {
        setHealerCourses([]);
        index = 1;
      }

      //api pagination index for infinite scrolling
      setListIndex(index);

      const payload = {
        name: filters?.name,
        modality: filters?.category?.value ?? "",
        state: filters?.state?.value ?? "",
        city: filters?.city,
        sort: filters?.sorting,
        page: index,
        timezone: moment.tz.guess(true),
      };

      const res = await healerServices.getHealerCourses(payload);
      setApiLoader(false);
      if (res.status) {
        if (res.data.data.length > 0) {
          setHealerCourses((prevHealers) => [
            ...new Map(
              [...prevHealers, ...res.data.data].map((item) => [
                item["id"],
                item,
              ])
            ).values(),
          ]);
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching healers:", error);
      setHasMore(false);
    }
  };

  const searchByName = () => {
    fetchHealerCourses({
      name: name,
      category: filters?.categoryType?.value ?? "",
      state: filters?.state?.value ?? "",
      city: filters?.city,
    });
  };

  useEffect(() => {
    const fetchCategoryTypes = async () => {
      const res = await healerServices.getModalities();
      if (res.status) {
        dispatch(
          setCategoryTypes(
            res.data.map((i) => ({ label: i.name, value: i.id }))
          )
        );
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
      }
    };

    const fetchStates = async () => {
      //default unites states country states
      const res = await healerServices.getStates(231);
      if (res.status) {
        dispatch(
          setStates(res.data.map((i) => ({ value: i.id, label: i.name })))
        );
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
      }
    };
    fetchStates();
    fetchCategoryTypes();
  }, [dispatch]);

  useEffect(() => {
    fetchHealerCourses();
  }, [filters]);

  useEffect(() => {
    if (hasMo) {
      dispatch(setEmptyFilter());
      dispatch(setName(""));
    }
  }, [filters]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      dispatch(setSelectedName(name));
    }
  };

  const filtersAreSelected = () => {
    const { name, state, city, sorting, category } = filters;
    return (
      (category && category.value) ||
      (state && state.value) ||
      city ||
      (sorting && sorting.value) ||
      name !== ""
    );
  };

  return (
    <>
      <Head>
        <title>{coursesMeta?.meta?.og_title}</title>
        <meta name="title" content={coursesMeta?.meta?.meta_title}></meta>
        <meta
          name="description"
          content={coursesMeta?.meta?.meta_description}
        ></meta>
        <meta name="keywords" content={coursesMeta?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={coursesMeta?.meta?.og_title}></meta>
        <meta property="og:image" content={coursesMeta?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/courses"></link>
        <meta
          property="og:description"
          content={coursesMeta?.meta?.meta_description}
        ></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={coursesMeta?.meta?.meta_title} />
        <meta
          name="twitter:description"
          content={coursesMeta?.meta?.meta_description}
        />
        <meta name="twitter:image" content={coursesMeta?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/courses" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="Healing Courses" />
        <meta property="og:image" content={coursesMeta?.meta?.og_image}></meta>
      </Head>
      <>
        <section
          className={styles["section-banner"] + " banner-hide-banner"}
          style={{ background: "url(/images/healerlisting-banner.jpg)" }}
          ref={firstSectionRef}
        >
          <Container>
            <Row>
              <Col md={8} className="m-auto">
                <div className={styles["inner-content"]}>
                  <h1 className={styles["banner-title"]}>courses offered</h1>
                  <h2>
                    Our verified healers are providing various courses in all
                    different modalities which anyone can learn and get
                    certified to help connect with your inner self and practice
                    self care.
                  </h2>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {apiLoader ? (
          <div className={styless.overlay}>
            <div className={styless.loader}>
              <Image
                width={151}
                height={159}
                src="/images/logo.svg"
                alt="Zenkify Logo"
              />
            </div>
          </div>
        ) : (
          <section className="listing-section">
            <Container className="searchbar-mobile">
              <Row className="filter-header">
                <Col lg={3} md={12} className="col-9">
                  <div className="search-bar classes-shearchbar">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-search-line"></i>
                      </span>
                      <Form.Control
                        type="text"
                        placeholder="Search by Course Name"
                        value={name}
                        onInput={(e) => dispatch(setName(e.target.value))}
                        onKeyDown={(e) => {
                          handleKeyPress(e);
                          setHasMo(false);
                        }}
                      />
                      <Button
                        className="search-bttn"
                        onClick={() => {
                          dispatch(setSelectedName(name));
                          setHasMo(false);
                        }}
                      >
                        <i className="ri-search-line"></i>
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col lg={9} md={12} className="col-3">
                  <div className="mobilefilter-course">
                    <InputGroup className="input-group mobile-sort">
                      <FormLabel>Sort by Pricing</FormLabel>
                      <Form.Select
                        className="w-100 SortbyPricingSelect"
                        name="extra"
                        id="extra"
                        value={filters.sorting}
                        onChange={(value) => {
                          dispatch(setSelectedSorting(value.target.value));
                          setHasMo(false);
                        }}
                        placeholder={"Select Option"}
                      >
                        <option value="">Please Select</option>
                        <option value="asc">Price: Low to High</option>
                        <option value="desc">Price: High to Low</option>
                      </Form.Select>
                    </InputGroup>

                    <div
                      className="course-filter"
                      onClick={() => setshowfilter(true)}
                    >
                      <div className="inner-box">
                        <span>Filter</span>
                        <i className="fa-solid fa-sliders"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`outerfilter-box ${setFilterPop ? "show" : " "}`}
                  >
                    <div className="filter-select mobile-filterselect">
                      <div className="header-mobilefilter">
                        <h6 className="filter-title">Filter </h6>
                        <i
                          className="ri-close-fill"
                          onClick={() => setshowfilter(false)}
                        ></i>
                      </div>
                      <InputGroup className="clearall-bttn">
                        {filtersAreSelected() ? (
                          <Button
                            type="button"
                            className="theme-btn"
                            onClick={() => {
                              dispatch(setEmptyFilter());
                              dispatch(setName(""));
                            }}
                          >
                            <span>Clear</span> <i className="fa fa-times"></i>
                          </Button>
                        ) : (
                          ""
                        )}
                      </InputGroup>
                      <InputGroup
                        className={
                          Object.keys(filters.category).length == 0
                            ? "input-group"
                            : "input-group active"
                        }
                      >
                        <i className="ri-file-list-line"></i>
                        <FormLabel>Modality</FormLabel>
                        <Select
                          className={
                            Object.keys(filters.category).length == 0
                              ? "w-100 custom-multi-select filter-header-Category"
                              : "w-100 custom-multi-select filter-header-Category active"
                          }
                          name="category_type_id"
                          id="category_type_id"
                          instanceId={"category_type_id"}
                          isSearchable={screenSize > 991 ? true : searchBar}
                          onMenuClose={() => {
                            setSearchBar(!searchBar);
                          }}
                          value={filters.category}
                          options={categoryTypes}
                          onChange={(value) => {
                            dispatch(setSelectedCategoryType(value));
                            setHasMo(false);
                          }}
                          placeholder={"Select Modality"}
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          Object.keys(filters.state).length == 0
                            ? "input-group"
                            : "input-group active"
                        }
                      >
                        <i className="ri-map-pin-line"></i>
                        <FormLabel>State</FormLabel>
                        <Select
                          className={
                            Object.keys(filters.state).length == 0
                              ? "w-100 custom-multi-select filter-header-state"
                              : "w-100 custom-multi-select filter-header-state active"
                          }
                          name="states"
                          id="states"
                          instanceId={"states"}
                          value={filters.state}
                          isSearchable={screenSize > 991 ? true : searchBar}
                          onMenuClose={() => {
                            setSearchBar(!searchBar);
                          }}
                          options={states}
                          onChange={(value) => {
                            dispatch(setSelectedState(value));
                            setHasMo(false);
                          }}
                          placeholder={"Select State"}
                        />
                      </InputGroup>
                      <InputGroup>
                        <InputGroup>
                          <i className="ri-map-pin-line"></i>
                          <FormLabel>City</FormLabel>
                          <Form.Control
                            className="filter-header-city courses-city-select"
                            type="text"
                            name="city"
                            value={filters.city}
                            placeholder="Enter city here..."
                            onInput={(e) => {
                              dispatch(setSelectedCity(e.target.value));
                              setHasMo(false);
                            }}
                          />
                        </InputGroup>
                      </InputGroup>
                      {screenSize > 717 ? (
                        <InputGroup
                          className={
                            filters.sorting == ""
                              ? "input-group Sortby-Select-drop"
                              : "input-group Sortby-Select-drop active"
                          }
                        >
                          {/* <Form.Label>Sort By</Form.Label> */}
                          <i className="ri-menu-2-line"></i>
                          <Select
                            className="w-100 SortbyPricingSelect"
                            name="extra"
                            styles={customStyles}
                            id="extra"
                            instanceId={"extra"}
                            isSearchable={false}
                            value={
                              filters.sorting == "asc"
                                ? {
                                    label: "Price: Low to High",
                                    value: "asc",
                                  }
                                : filters.sorting == "desc"
                                ? {
                                    label: "Price: High to Low",
                                    value: "desc",
                                  }
                                : ""
                            }
                            options={[
                              {
                                label: "Price: Low to High",
                                value: "asc",
                              },
                              {
                                label: "Price: High to Low",
                                value: "desc",
                              },
                            ]}
                            onChange={(value) => {
                              dispatch(setSelectedSorting(value.value));
                              setHasMo(false);
                            }}
                            placeholder={"Sort By"}
                          />
                        </InputGroup>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div
                    className={`outerfilter-boxOverlay ${
                      setFilterPop ? "show" : " "
                    }`}
                    onClick={() => setshowfilter(false)}
                  ></div>
                </Col>
              </Row>
            </Container>
            <Container>
              <InfiniteScroll
                dataLength={healerCourses.length}
                next={() => fetchHealerCourses(true)}
                hasMore={hasMore}
                loader={
                  <div className="text-center mt-5">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                }
                // endMessage={
                //   <div className="text-center mt-5">
                //     <span className="text-center">
                //       All the healer courses are listed!
                //     </span>
                //   </div>
                // }
                style={{ overflow: "hidden" }}
              >
                <Row>
                  {healerCourses
                    ? healerCourses?.map((item, index) => {
                        return (
                          <Col sm={6} md={4} className="mb-4" key={index}>
                            <div className="courses-card">
                              {item?.is_free ? (
                                <p className="free p-3">FREE</p>
                              ) : (
                                ""
                              )}
                              <div className="courses-content">
                                <h3>
                                  {(item?.class?.name?.length > 25
                                    ? item?.class?.name?.slice(0, 110)
                                    : item?.class?.name) ?? "Not Specified"}
                                </h3>
                                <h4>
                                  {(item?.class?.short_description?.length > 25
                                    ? item?.class?.short_description?.slice(
                                        0,
                                        150
                                      )
                                    : item?.class?.short_description) ??
                                    "Not Specified"}
                                </h4>
                                <ul>
                                  <li>
                                    <i className="ri-time-line"></i>{" "}
                                    <span>
                                      {item?.class?.duration
                                        ? item?.class?.duration + " Days"
                                        : "Not Specified"}
                                    </span>
                                  </li>
                                  <li>
                                    <i className="ri-user-3-line"></i>{" "}
                                    <span>
                                      {item?.booking_type?.name == "Both"
                                        ? "In Person & Online Session"
                                        : item?.booking_type?.name}
                                    </span>
                                  </li>
                                </ul>
                                <Link
                                  href={`/courses/${item.slug}/detail`}
                                  // href={`/courses/${
                                  //   item?.class?.id
                                  // }-${item.class.name
                                  //   .toLowerCase()
                                  //   .replaceAll(" ", "-")}-${item?.id}/detail`}
                                  className="theme-btn"
                                >
                                  Book Class{" "}
                                  <i className="ri-arrow-right-line"></i>
                                </Link>
                              </div>
                            </div>
                          </Col>
                        );
                      })
                    : ""}
                </Row>
              </InfiniteScroll>
            </Container>
          </section>
        )}
      </>
      <Link
        id="floatingBook"
        className="floating-book"
        aria-label="Book a FREE call now"
        href="/healers"
        style={{ opacity: showSideButton ? 1 : 0 }}
      >
        Book a FREE call now
      </Link>
    </>
  );
};

Courselisting.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export default Courselisting;

// ssr
export async function getServerSideProps() {
  const fetchCoursesMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("courses");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const coursesMeta = (await fetchCoursesMeta()) ?? {};

  // Pass data to the page via props
  return { props: { coursesMeta } };
}
